import { CoAddressService } from '@core/services/api/co/co-address.service';
import { CoCompanyService } from '@core/services/api/co/co-company.service';
import { CuCustomerService } from '@core/services/api/cu/cu-customer.service';
import { CuCustomerLinkService } from '@core/services/api/cu/cu-customer-link.service';
import { CuFamilyService } from '@core/services/api/cu/cu-family.service';
import { CuGroupService } from '@core/services/api/cu/cu-group.service';
import { PrBrandService } from '@core/services/api/pr/pr-brand.service';
import { PrCategoryService } from '@core/services/api/pr/pr-category.service';
import { PrCeService } from '@core/services/api/pr/pr-ce.service';
import { PrProductKitService } from '@core/services/api/pr/pr-product-kit.service';
import { PrProductService } from '@core/services/api/pr/pr-product.service';
import { PrProductUnitNameService } from '@core/services/api/pr/pr-product-unit-name.service';
import { SaPickingService } from '@core/services/api/sa/sa-picking.service';
import { SaSaleOrderService } from '@core/services/api/sa/sa-sale-order.service';
import { StWorkOrderService } from '@core/services/api/st/st-work-order.service';
import { SuReceiptService } from '@core/services/api/su/su-receipt.service';
import { SuSupplierService } from '@core/services/api/su/su-supplier.service';
import { SuSupplyOrderService } from '@core/services/api/su/su-supply-order.service';
import { TmDeliveryZoneService } from '@core/services/api/tm/tm-delivery-zone.service';
import { TmTransporterService } from '@core/services/api/tm/tm-transporter.service';
import { SelectService } from '@core/services/select.service';
import { WaWarehouseService } from '@core/services/api/wa/wa-warehouse.service';
import { StTransferService } from '@core/services/api/st/st-transfer.service';
import { SaPickingWaveService } from '@core/services/api/sa/sa-picking-wave.service';
import { SaDeliveryNoteService } from '@core/services/api/sa/sa-delivery-note.service';
import { InvoiceService } from '@core/services/api/invoice.service';
import { CuDepartmentService } from '@core/services/api/cu/cu-department.service';
import { CuSeniorService } from '@core/services/api/cu/cu-senior.service';
import { TmDeliveryTourService } from '@core/services/api/tm/tm-delivery-tour.service';
import { CuDueDateTypeService } from '@core/services/api/cu/cu-due-date-type.service';
import { SePrinterService } from '@core/services/api/se/se-printer.service';
import { SaPickingNotValidatedMessageService } from '@core/services/api/sa/sa-picking-not-validated-message.service';

export const ALL_SERVICES: Record<string, any> = {
    CoAddressService,
    CoCompanyService,
    CuDueDateTypeService,
    CuCustomerService,
    CuCustomerLinkService,
    CuFamilyService,
    CuGroupService,
    CuDepartmentService,
    CuSeniorService,
    InvoiceService,
    PrBrandService,
    PrCategoryService,
    PrCeService,
    PrProductKitService,
    PrProductService,
    PrProductUnitNameService,
    SaDeliveryNoteService,
    SaPickingService,
    SaPickingNotValidatedMessageService,
    SaPickingWaveService,
    SaSaleOrderService,
    SePrinterService,
    StTransferService,
    StWorkOrderService,
    SuReceiptService,
    SuSupplierService,
    SuSupplyOrderService,
    TmDeliveryTourService,
    TmDeliveryZoneService,
    TmTransporterService,
    SelectService,
    WaWarehouseService,
}
